module.exports = __webpack_public_path__ + "img/incognite.c291e42c.svg";